import React from "react";
import ButtonStyled from "./component.styled.ts";

const ButtonBase = ({
  type,
  backgroundColor,
  hoverColor,
  color,
  width,
  onClick,
  onSubmit,
  children,
  className,
  size,
  border,
}: {
  type?: JSX.IntrinsicElements["button"]["type"];
  backgroundColor?: string;
  hoverColor?: string;
  color?: string;
  width?: string;
  size?: string;
  border?: string;
  onClick?: JSX.IntrinsicElements["button"]["onClick"];
  onSubmit?: JSX.IntrinsicElements["button"]["onSubmit"];
  className?: JSX.IntrinsicElements["button"]["className"];
  children: React.ReactNode;
}) => {
  return (
    <ButtonStyled
      className={className}
      type={type || "button"}
      onClick={onClick}
      onSubmit={onSubmit}
      backgroundColor={backgroundColor}
      hoverColor={hoverColor}
      color={color}
      width={width}
      size={size || "LG"}
      border={border || "none"}
    >
      {children}
    </ButtonStyled>
  );
};

export default ButtonBase;
